<div class="filters-container" *ngIf="(filters$ | async);let filters">
  <ng-container *ngIf="filters.length > 1">
    <div class="filters-container__title"
    [class.filters-container__title--no-margin]="!(areFiltersAvailable$ | async)">
      <h4>
        Selecciona tu habitación
      </h4>
    </div>

    <am-room-filters-responsive></am-room-filters-responsive>
  </ng-container>
</div>

